import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { AuthLayout } from '@/layout/AuthLayout';
import { DashboardLayout } from '@/layout/DashboardLayout';
import { MainLayout } from '@/layout/MainLayout';
import Assets from '@/pages/assets';
import AssetDetail from '@/pages/assets/AssetDetail';
import AssetTransferPage from '@/pages/assetTransfer';
import CustomersPage from '@/pages/customers';
import CustomerInvestments from '@/pages/customers/CustomerInvestments';
import Dashboard from '@/pages/dashboard/Dashboard';
import ForgotPassword from '@/pages/forgotPassword';
import InvestmentsPage from '@/pages/investments';
import InvestmentDetail from '@/pages/investments/InvestmentDetail';
import KnowledgeBasePage from '@/pages/knowledgeBase';
import NFTManagementPage from '@/pages/nft-management/NftManagement';
import ResetPassword from '@/pages/resetPassword';
import SignIn from '@/pages/signIn';
import TestingPage from '@/pages/testing';
import WalletOpsPage from '@/pages/walletOps';

const AppRouter = () => {
  const router = createBrowserRouter([
    {
      element: <MainLayout />,
      children: [
        {
          element: <AuthLayout />,
          children: [
            {
              element: <SignIn />,
              path: '/sign-in',
            },
            {
              path: '/forgot-password',
              element: <ForgotPassword />,
            },
            {
              path: '/reset-password',
              element: <ResetPassword />,
            },
          ],
        },
        {
          element: <DashboardLayout />,
          children: [
            {
              path: '/',
              element: <Dashboard />,
            },
            {
              path: '/dashboard',
              element: <Dashboard />,
            },
            {
              path: '/nfts',
              element: <NFTManagementPage />,
            },
            {
              path: '/admin/investments',
              element: <InvestmentsPage />,
            },
            {
              path: '/admin/investments/:investmentId',
              element: <InvestmentDetail />,
            },
            {
              path: '/admin/customers',
              element: <CustomersPage />,
            },
            {
              path: '/admin/customers/:customerId',
              element: <CustomerInvestments />,
            },
            {
              path: '/assets',
              element: <Assets />,
            },
            {
              path: '/assets/:id',
              element: <AssetDetail />,
            },
            {
              path: '/wallet-ops',
              element: <WalletOpsPage />,
            },
            {
              path: '/asset-transfer',
              element: <AssetTransferPage />,
            },
            {
              path: '/testing',
              element: <TestingPage />,
            },
            {
              path: '/knowledge-base',
              element: <KnowledgeBasePage />,
            },
            // {
            //   path: '/admins',
            //   element: <Admins />,
            // },

            // {
            //   path: '/products',
            //   element: <Product />,
            // },
            // {
            //   path: '/add-product',
            //   element: <CreateProduct />,
            // },
            // {
            //   path: '/product-categories',
            //   element: <Categories />,
            // },
            // {
            //   path: '/press-and-media',
            //   element: <PressAndMediaList />,
            // },
            //  {
            //   path: '/support-tickets',
            //   element: <SupportTickets />,
            // },
            //  {
            //   path: '/orders',
            //   element: <Orders />,
            // },
            {
              path: '*',
              element: (
                <div className="flex flex-col items-center justify-center">
                  <h1 className="text-2xl">404 Not Found</h1>
                  <p>Sorry, the page you are looking for does not exist.</p>
                </div>
              ),
            },
          ],
        },
      ],
    },
  ]);

  {
    return (
      <>
        <RouterProvider router={router} />
      </>
    );
  }
};
export default AppRouter;
